export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/build-with-ai.4f31f242.svg","height":203,"width":320,"blurWidth":0,"blurHeight":0};